import VueRouter from 'vue-router'

import Login from '@/views/Login'
import NotFound from '@/views/404'
import Home from '@/views/Home'

const getView = view => require(`@/views/${view}`).default

let routes = [
  {
    path: '/login',
    component: Login,
    name: 'Login',
    hidden: true,
    meta: {
      guests: true
    }
  },
  {
    path: '/404',
    component: NotFound,
    name: '404',
    hidden: true,
    meta: {
      guests: true
    }
  },
  {
    path: '/',
    component: Home,
    name: 'Home',
    iconCls: 'el-icon-star-on',
    meta: { label: 'Home' },
    redirect: {
      name: 'Dashboard'
    },
    hidden: true
  },
  {
    path: '/dashboard',
    component: Home,
    iconCls: 'fa fa-tachometer',
    meta: { label: 'Dashboard' },
    children: [
      {
        path: '',
        component: getView('Dashboard/Dashboard'),
        name: 'Dashboard',
        iconCls: 'el-icon-star-on',
        meta: { label: 'Home' }
      }
    ]
  },
  {
    path: '/articles',
    component: Home,
    iconCls: 'fa fa-file-text-o',
    meta: { label: 'Articles' },
    children: [
      {
        path: '',
        component: getView('Articles/ArticleList'),
        name: 'Articles List',
        meta: { label: 'Articles list' }
      },
      {
        path: 'add',
        component: getView('Articles/ArticleForm'),
        name: 'Add Article',
        meta: { label: 'Add article' }
      },
      {
        path: ':id',
        props: true,
        component: getView('Articles/ArticleForm'),
        name: 'Edit Article',
        hidden: true,
        meta: { label: 'Edit article' }
      }
    ]
  },
  {
    path: '/applications',
    component: Home,
    iconCls: 'fa fa-paper-plane',
    meta: { label: 'Applications', permissions: ['has_applications_access'] },
    children: [
      {
        path: '',
        component: getView('Application/ApplicationList'),
        name: 'Application List',
        meta: { label: 'Applications List' }
      },
      {
        path: ':id',
        props: true,
        component: getView('Application/ApplicationForm'),
        name: 'Edit Application',
        hidden: true,
        meta: { label: 'Application' }
      }
    ]
  },
  {
    path: '/pages',
    component: Home,
    iconCls: 'fa fa-desktop',
    meta: { label: 'Pages' },
    children: [
      {
        path: '',
        component: getView('Pages/PagesList'),
        name: 'Pages List',
        meta: { label: 'List pages' }
      },
      {
        path: 'add',
        component: getView('Pages/PageForm'),
        name: 'Add Page',
        meta: { label: 'Add page' }
      },
      {
        path: ':id',
        props: true,
        component: getView('Pages/PageForm'),
        name: 'Edit Page',
        hidden: true,
        meta: { label: 'Edit page' }
      }
    ]
  },
  {
    path: '/contact',
    component: Home,
    iconCls: 'fa fa-envelope',
    meta: { label: 'Contact' },
    children: [
      {
        path: 'messages',
        component: getView('Contact/MessagesList'),
        name: 'Message List',
        meta: { label: 'Message List' }
      },
      {
        path: 'messages/:id',
        props: true,
        component: getView('Contact/MessageForm'),
        name: 'Edit Message',
        hidden: true,
        meta: { label: 'View Message' }
      }
    ]
  },
  {
    path: '/images',
    component: Home,
    iconCls: 'fa fa-image',
    meta: { label: 'Images' },
    children: [
      {
        path: '',
        component: getView('Image/ImageList'),
        name: 'Image List',
        meta: { label: 'List images' }
      },
      {
        path: 'add',
        component: getView('Image/ImageForm'),
        name: 'Add Image',
        meta: { label: 'Add image' }
      },
      {
        path: ':id',
        props: true,
        component: getView('Image/ImageForm'),
        name: 'Edit Image',
        hidden: true,
        meta: { label: 'Edit image' }
      }
    ]
  },
  {
    path: '/attachments',
    component: Home,
    iconCls: 'fa fa-download',
    meta: { label: 'Attachments' },
    children: [
      {
        path: '',
        component: getView('Attachments/AttachmentsList'),
        name: 'Attachments List',
        meta: { label: 'List attachment' }
      },
      {
        path: 'public',
        component: getView('Attachments/PublicAttachmentsList'),
        name: 'Public attachments List',
        meta: { label: 'List public attachment' }
      }
    ]
  },
  {
    path: '/menu',
    component: Home,
    iconCls: 'fa fa-bars',
    meta: { label: 'Menu' },
    children: [
      {
        path: 'main-menu',
        props: {
          default: true,
          id: 'main-menu'
        },
        component: getView('Menus/MainMenuForm'),
        name: 'Edit Menu',
        meta: { label: 'Edit main menu' }
      },
      {
        path: 'language-menu',
        props: {
          default: true,
          id: 'language-menu'
        },
        component: getView('Menus/LanguageMenuForm'),
        name: 'Edit Language Menu',
        meta: { label: 'Edit language menu' }
      }
    ]
  },
  {
    path: '/users',
    component: Home,
    iconCls: 'fa fa-group',
    meta: { label: 'Users', permissions: ['has_applications_access'] },
    children: [
      {
        path: '',
        component: getView('User/UserList'),
        name: 'User List',
        meta: { label: 'List users' }
      },
      {
        path: 'add',
        component: getView('User/UserForm'),
        name: 'Add User',
        meta: { label: 'Add user' }
      },
      {
        path: ':id',
        props: true,
        component: getView('User/UserForm'),
        name: 'Edit User',
        hidden: true,
        meta: { label: 'Edit user' }
      }
    ]
  },
  {
    path: '/settings',
    component: Home,
    iconCls: 'fa fa-cog',
    meta: { label: 'Settings' },
    children: [
      {
        path: 'page',
        component: getView('Settings/PageSettingsForm'),
        name: 'Page Settings Form',
        meta: { label: 'Site settings' }
      }
    ]
  },
  {
    path: '*',
    hidden: true,
    redirect: { path: '/404' }
  }
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  const isUserLoggedIn = window.localStorage.getItem('token')
  if (!to.meta.guests && !isUserLoggedIn) {
    next({ name: 'Login', query: { next: to.path } })
    return
  }
  document.title = to.meta.label
    ? `${to.meta.label} - Admin panel`
    : 'Admin panel'
  next()
})

export default router
